import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column } from "@faire/web--source/slate/Layout";
import React from "react";
import { SDUICarousel } from "@faire/retailer/components/SDUI/ComponentRenderers/Carousel/__internal__/SDUICarousel";
import { SDUICarouselHeaderRow } from "@faire/retailer/components/SDUI/ComponentRenderers/Carousel/__internal__/SDUICarouselHeaderRow";
export var SDUICarouselRenderer = function(param) {
    var component = param.component, loggingData = param.loggingData, renderBehaviour = param.renderBehaviour;
    var carouselElement = component.carousel_component;
    if (!carouselElement) {
        return null;
    }
    var title = carouselElement.title, cta_button = carouselElement.cta_button, sub_title = carouselElement.sub_title, tiles = carouselElement.tiles, tagline = carouselElement.tagline, style = carouselElement.style;
    if (tiles === undefined || tiles.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Column, {
        className: "md:px-12",
        "data-test-id": "carousel-renderer",
        children: [
            /*#__PURE__*/ _jsx(SDUICarouselHeaderRow, {
                title: title,
                cta_button: cta_button,
                sub_title: sub_title,
                tagline: tagline,
                loggingData: loggingData
            }),
            /*#__PURE__*/ _jsx(SDUICarousel, {
                style: style,
                tiles: tiles,
                loggingData: loggingData,
                renderBehaviour: renderBehaviour
            })
        ]
    });
};
